import { BASE_URI } from "../constants/api"

export const addBackEndDomain = (url: string) => {
  let separator = "";
  if (url.charAt(0) !== '/') {
    separator = "/";
  }
  return BASE_URI + separator + url;
}